import { render, staticRenderFns } from "./CustomerDistribution.vue?vue&type=template&id=2cdef43c"
import script from "./CustomerDistribution.vue?vue&type=script&lang=js"
export * from "./CustomerDistribution.vue?vue&type=script&lang=js"
import style0 from "./CustomerDistribution.vue?vue&type=style&index=0&id=2cdef43c&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cdef43c')) {
      api.createRecord('2cdef43c', component.options)
    } else {
      api.reload('2cdef43c', component.options)
    }
    module.hot.accept("./CustomerDistribution.vue?vue&type=template&id=2cdef43c", function () {
      api.rerender('2cdef43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/CPPerformanceReport/components/CustomerDistribution.vue"
export default component.exports